import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import HomeStackScreen from './HomeStackScreen';
import { AppRoute } from './types';

const AppStack = createStackNavigator();

export default function AppRoutes() {
  return (
    <AppStack.Navigator screenOptions={{ animationEnabled: true, headerShown: false }}>
      <AppStack.Screen name={AppRoute.HOME_STACK_SCREEN} component={HomeStackScreen} />
    </AppStack.Navigator>
  );
}
